var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7777 6.60156H1.89502C1.61902 6.60156 1.39502 6.37756 1.39502 6.10156C1.39502 5.82556 1.61902 5.60156 1.89502 5.60156H13.7777C14.0537 5.60156 14.2777 5.82556 14.2777 6.10156C14.2777 6.37756 14.0537 6.60156 13.7777 6.60156Z",
    fill: "#5D6373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8009 9.20508C10.5249 9.20508 10.2982 8.98108 10.2982 8.70508C10.2982 8.42908 10.5189 8.20508 10.7949 8.20508H10.8009C11.0769 8.20508 11.3009 8.42908 11.3009 8.70508C11.3009 8.98108 11.0769 9.20508 10.8009 9.20508Z",
    fill: "#5D6373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84251 9.20508C7.56651 9.20508 7.33984 8.98108 7.33984 8.70508C7.33984 8.42908 7.56051 8.20508 7.83651 8.20508H7.84251C8.11851 8.20508 8.34251 8.42908 8.34251 8.70508C8.34251 8.98108 8.11851 9.20508 7.84251 9.20508Z",
    fill: "#5D6373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87797 9.20508C4.60197 9.20508 4.37463 8.98108 4.37463 8.70508C4.37463 8.42908 4.59597 8.20508 4.87197 8.20508H4.87797C5.15397 8.20508 5.37797 8.42908 5.37797 8.70508C5.37797 8.98108 5.15397 9.20508 4.87797 9.20508Z",
    fill: "#5D6373"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8009 11.7969C10.5249 11.7969 10.2982 11.5729 10.2982 11.2969C10.2982 11.0209 10.5189 10.7969 10.7949 10.7969H10.8009C11.0769 10.7969 11.3009 11.0209 11.3009 11.2969C11.3009 11.5729 11.0769 11.7969 10.8009 11.7969Z",
    fill: "#5D6373"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84251 11.7969C7.56651 11.7969 7.33984 11.5729 7.33984 11.2969C7.33984 11.0209 7.56051 10.7969 7.83651 10.7969H7.84251C8.11851 10.7969 8.34251 11.0209 8.34251 11.2969C8.34251 11.5729 8.11851 11.7969 7.84251 11.7969Z",
    fill: "#5D6373"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87797 11.7969C4.60197 11.7969 4.37463 11.5729 4.37463 11.2969C4.37463 11.0209 4.59597 10.7969 4.87197 10.7969H4.87797C5.15397 10.7969 5.37797 11.0209 5.37797 11.2969C5.37797 11.5729 5.15397 11.7969 4.87797 11.7969Z",
    fill: "#5D6373"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5291 3.86002C10.2531 3.86002 10.0291 3.63602 10.0291 3.36002V1.16602C10.0291 0.890016 10.2531 0.666016 10.5291 0.666016C10.8051 0.666016 11.0291 0.890016 11.0291 1.16602V3.36002C11.0291 3.63602 10.8051 3.86002 10.5291 3.86002Z",
    fill: "#5D6373"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14355 3.86002C4.86755 3.86002 4.64355 3.63602 4.64355 3.36002V1.16602C4.64355 0.890016 4.86755 0.666016 5.14355 0.666016C5.41955 0.666016 5.64355 0.890016 5.64355 1.16602V3.36002C5.64355 3.63602 5.41955 3.86002 5.14355 3.86002Z",
    fill: "#5D6373"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33337 1.71875H14.3334V14.9993H1.33337V1.71875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01404 2.71875C3.28537 2.71875 2.33337 3.64075 2.33337 5.31475V11.3474C2.33337 13.0581 3.28537 13.9994 5.01404 13.9994H10.6527C12.3814 13.9994 13.3334 13.0754 13.3334 11.3981V5.31475C13.336 4.49142 13.1147 3.85142 12.6754 3.41142C12.2234 2.95808 11.5267 2.71875 10.6587 2.71875H5.01404ZM10.6527 14.9994H5.01404C2.74404 14.9994 1.33337 13.6001 1.33337 11.3474V5.31475C1.33337 3.09608 2.74404 1.71875 5.01404 1.71875H10.6587C11.798 1.71875 12.74 2.06008 13.3834 2.70475C14.008 3.33208 14.3367 4.23408 14.3334 5.31608V11.3981C14.3334 13.6194 12.9227 14.9994 10.6527 14.9994Z",
    fill: "#5D6373"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ec055fdab478c40ddc31e7e3d6528b60.svg";
export { ForwardRef as ReactComponent };